import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  SubscriptionProductDto,
  SubscriptionProductUpdateRequestDto,
} from "@/dto/SubscriptionDto";
import { Yn } from "@/constants/code";
import { useEffect } from "react";

export default function useEditForm(
  subscriptionInfo: SubscriptionProductDto,
  onSubmit: (data: SubscriptionProductUpdateRequestDto, id: string) => void
) {
  const schema = yup.object().shape({
    productId: yup.string().required(),
    productNm: yup.string().required("상품명을 입력해주세요."),
    productType: yup.string().required("상품 유형을 선택해주세요."),
    productDtl: yup.string().required("상품 상세 설명을 입력해주세요."),
    firstYearAmt: yup.string().required("연간 금액을 입력해주세요."),
    monthlyAmt: yup.string().required("월간 금액을 입력해주세요."),
    currency: yup.string().required("통화를 선택해주세요."),
    prepaidPeriod: yup
      .number()
      .required("선납 기간을 입력해주세요.")
      .min(1, "1개월 이상을 입력해주세요.")
      .max(12, "12개월 이하를 입력해주세요."),
    activeYn: yup.mixed<Yn>().oneOf([Yn.Y, Yn.N]).required(),
    regDttm: yup.string().required(),
    regAdmId: yup.string().required(),
  }) as yup.ObjectSchema<SubscriptionProductDto>;

  const methods = useForm<SubscriptionProductDto>({
    resolver: yupResolver(schema),
    defaultValues: {
      productId: "",
      productNm: "",
      productType: "",
      productDtl: "",
      firstYearAmt: "",
      monthlyAmt: "",
      currency: "USD",
      prepaidPeriod: 12,
      activeYn: Yn.Y,
      regDttm: "",
      regAdmId: "",
    },
  });

  // subscriptionInfo가 변경될 때마다 폼 값을 업데이트
  useEffect(() => {
    if (subscriptionInfo) {
      methods.reset({
        ...subscriptionInfo,
        productNm: subscriptionInfo.productNm,
        productType: subscriptionInfo.productType,
        productDtl: subscriptionInfo.productDtl,
        firstYearAmt: subscriptionInfo.firstYearAmt,
        monthlyAmt: subscriptionInfo.monthlyAmt,
        currency: subscriptionInfo.currency,
        prepaidPeriod: subscriptionInfo.prepaidPeriod,
        activeYn: subscriptionInfo.activeYn,
        productId: subscriptionInfo.productId,
        regDttm: subscriptionInfo.regDttm,
        regAdmId: subscriptionInfo.regAdmId,
      });
    }
  }, [subscriptionInfo, methods]);

  return {
    methods,
    handleSubmit: methods.handleSubmit(
      (data) => {
        const updateData: SubscriptionProductUpdateRequestDto = {
          productNm: data.productNm,
          productType: data.productType,
          productDtl: data.productDtl,
          firstYearAmt: Number(data.firstYearAmt),
          monthlyAmt: Number(data.monthlyAmt),
          currency: data.currency,
          prepaidPeriod: data.prepaidPeriod,
          activeYn: data.activeYn,
        };
        return onSubmit(updateData, data.productId);
      },
      (errors) => {
        console.error("Form validation errors:", errors);
      }
    ),
  };
}
